import React, { useMemo } from "react";

// @ts-ignore
import AthenaLogo from "../../assets/Athena_owlLogo.png";
// @ts-ignore
import sourcesLink from "../../assets/docs/Athena Sources.pdf";
import { HeaderSearch, ScaleTypeDropdown, ScaleSettings } from "mcmap-lib";
import { SearchTab } from "mcmap-lib/src/interfaces/headerSearch";
import { useStore } from "mcmap-lib/src/stores/store";
import SalesUi from "./SalesUi";

function Header(props: { title: string; subtitle: string }) {
  const searchTabs: SearchTab[] = useMemo(
    () => [
      {
        label: "Parcel",
        value: "parcel",
        placeholder: "Enter parcel (08-32-201-004)",
        field: "ParcelNumber",
        layerId: "parcels",
        default: true,
        getWhereClause: (searchVal, parcelItems) => {
          if (!parcelItems || parcelItems.length === 0)
            return `ParcelNumber like '${searchVal}%'`;
          const where = `ParcelNumber in (${parcelItems
            .map((item) => `'${item.value}'`)
            .join(",")})`;
          return where;
        },
        isMobile: true,
      },
      {
        label: "Subdivision",
        value: "subdivision",
        queryUrl:
          "https://www.mchenrycountygis.org/ArcGIS/rest/services/subdivisions/MapServer/0",
        field: "NAME",
        placeholder: "Enter a subdivision name",
      },
      {
        label: "Address",
        value: "address",
        placeholder: "Enter an address",
        layerId: "parcels",
        field: "SiteAddress",
        secondaryFields: ["SiteCity", "SiteZip"],
        formatOptionLabel: (dataVal, searchVal, data) => {
          return `${data["SiteAddress"]}, ${data["SiteCity"]}, IL ${data["SiteZip"]}`;
        },
        internalOnly: true,
        isMobile: true,
      },
      {
        label: "Owner",
        value: "owner",
        layerId: "parcels",
        field: "Owner",
        fuzzySearch: true,
        placeholder: "Enter an owner name",
        internalOnly: true,
        isMobile: true,
      },
      {
        label: "Sales",
        value: "sales",
        layerId: "parcels",
        customUI: SalesUi,
        extraAttributesLookupKey: "ParcelNumber",
        isMobile: true,
        getExtraAttributesLookup: async () => {
          const state = useStore.getState();
          const res = await fetch(state.salesUrl);
          const json = await res.json();
          if (json.length === 0) return [];
          return json.map((sale: any) => {
            sale.ParcelNumber = `${sale.ParcelNumber.slice(
              0,
              2
            )}-${sale.ParcelNumber.slice(2, 4)}-${sale.ParcelNumber.slice(
              4,
              7
            )}-${sale.ParcelNumber.slice(7)}`;
            return sale;
          });
        },
        getWhereClause: async () => {
          const state = useStore.getState();
          const res = await fetch(state.salesUrl);
          const json = await res.json();
          const parcelNumbers = json
            .map(
              (sale: {
                Amount: string;
                DateOfSale: string;
                ParcelNumber: string;
                Township: string;
              }) => {
                const formattedParcelNumber =
                  sale.ParcelNumber.slice(0, 2) +
                  "-" +
                  sale.ParcelNumber.slice(2, 4) +
                  "-" +
                  sale.ParcelNumber.slice(4, 7) +
                  "-" +
                  sale.ParcelNumber.slice(7);
                return `'${formattedParcelNumber}'`;
              }
            )
            .join(",");
          if (parcelNumbers === "") return "1=0";

          return `ParcelNumber in (${parcelNumbers})`;
        },
      },
    ],
    []
  );
  return (
    <header
      className="h-24 text-white flex justify-between items-center font-trebuchet"
      style={{ background: "linear-gradient(to bottom, #424242, #646464)" }}
    >
      <div className="items-center hidden md:flex">
        <img src={AthenaLogo} alt="Athena Logo" className="py-2" />
        <div className="lg:hidden">
          <h4 className="font-semibold text-sm">Athena</h4>
          <p className="text-xs">{props.subtitle}</p>
        </div>
        <div className="hidden lg:block">
          <h4 className="font-semibold text-sm">{props.title}</h4>
          <p className="text-xs">{props.subtitle}</p>
          <ScaleSettings />
        </div>
      </div>
      <div className="flex-1 mx-4 lg:flex-initial lg:mx-0">
        <HeaderSearch tabs={searchTabs} />
      </div>
      <div className="px-4 font-semibold hidden lg:block">
        <p className="text-xs">Questions or comments?</p>
        <p className="text-xs">
          Email:{" "}
          <a
            href="mailto:gis@mchenrycountyil.gov"
            className="underline hover:text-mchenry-orange"
          >
            gis@mchenrycountyil.gov
          </a>{" "}
          |{" "}
          <a
            href={sourcesLink}
            target="_blank"
            rel="noreferrer"
            className="underline hover:text-mchenry-orange"
          >
            Sources
          </a>
        </p>
        <ScaleTypeDropdown />
      </div>
    </header>
  );
}
export default Header as React.FC<{ title: string; subtitle: string }>;
